var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-class page-setting-list"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),_c('table-box',{attrs:{"columns":_vm.columns,"rows":_vm.storeList,"baseUrl":_vm.baseUrl,"loading":_vm.loading,"emptyText":"No store found.","showAdd":false},on:{"edit":_vm.onEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }